import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Iteration } from '../models/iteration';
import { RouteChildrenTableComponent } from './route-children-table/route-children-table.component';

/**
 * Tabela do histórico de tierações (execuções) da heurística das rotas de 
 * atendimento de ocorrências.
 */
@Component({
  selector: 'app-route-iteration-table',
  templateUrl: './route-iteration-table.component.html',
  styleUrls: ['./route-iteration-table.component.css']
})
export class RouteIterationTableComponent implements OnInit {

  /** Controla a visibilidade do componente. */
  isVisible = false;

  /** IDs das iterações da heurística das rotas que foram selecionados. */
  selectedIterations: Iteration[] = [];

  routeChildrenTableRows: { iteration_id: number, segment_id: number }[] = [];

  /** Dados da lista de iterações. */
  iterations: Iteration[] = [];

  /** Nomes dos atributos da iteração, usados como colunas na tabela. */
  displayedColumns = ['iteration_id', 'iteration_time', 'best_heuristic_value'];

  /** Evento de seleção de iterações na tabela, para que o mapa exiba as respectivas rotas. */
  @Output() getHistoryGeometries = new EventEmitter<number[]>();

  constructor() { }

  ngOnInit(): void {
  }

  /** Altera o estado de exibição do componente para aberto (visível). */
  open() {
    this.isVisible = true;
  }

  /** Altera o estado de exibição do componente para fechado (invisível). */
  close() {
    this.isVisible = false;
  }

  /**
   * Define a lista de iterações exibidas.
   * @param iterations Lista de iterações da heurística das rotas a serem exibidas na tabela.
   */
  setDataSource(iterations: Iteration[]) {
    this.iterations = iterations;
  }

  /**
   * Trata o click em uma linha da tabela. 
   * Adiciona ou remove o ID da linha clicada do array de IDs selecionados.
   * @param row iteração da linha selecionada.
   * @returns 
   */
  onRowClicked(row: Iteration) {

    let selected = this.isRowSelected(row);

    if (selected == false) {
      this.addIteration(row);
      return;
    }

    this.removeIteration(row);
  }

  /**
   * Verifica se o ID da iteração está no array de IDs selecionados.
   * @param row iteração.
   * @returns true se o ID da iteração está no array dos IDs selecionados; false, caso contrário.
   */
  isRowSelected(row: Iteration) {
    return this.selectedIterations.includes(row);
  }

  /**
   * Obtém o array de classes CSS da linha da tabela.
   * Se o ID da iteração for o primeiro elemento do array, a linha será vermelha.
   * Se o ID for o segundo elemento, a linha será verde. Se a iteração não tiver sido
   * selecionada, seu ID não está no array, e por isso a linha não é colorida.
   * 
   * @param row iteração correspondente à linha da tabela.
   * @returns array de classes CSS.
   */
  getRowClasses(row: Iteration) {
    let classes = ['tbody-tr'];

    let index = this.selectedIterations.indexOf(row);

    if (index > -1) {
      classes.push(`selected-${index}`);
    }

    return classes;
  }

  /**
   * Marca uma iteração para que sua rota seja exibida no mapa. 
   * Só é possível marcar duas iterações por vez,
   * para que seja viável comparar as duas rotas geradas.
   * 
   * @param target checkbox relacionado à iteração
   * @param iteration dados da iteração
   * @returns 
   */
  private addIteration(iteration: Iteration) {

    if (this.selectedIterations.length >= 2) {
      return;
    }
    this.selectedIterations.push(iteration);
    this.emitSelectedIterationIds();
    this.updateRouteChildrenTableRows();
  }


  /**
   * Marca uma iteração para que sua rota seja removida do mapa.
   * 
   * @param target checkbox relacionado à iteração
   * @param iteration dados da iteração
   * @returns 
   */
  private removeIteration(iteration: Iteration) {

    let index = this.selectedIterations.indexOf(iteration);
    if (index === -1) {
      return;
    }
    this.selectedIterations.splice(index, 1);
    this.emitSelectedIterationIds();
    this.updateRouteChildrenTableRows();
  }

  /**
   * 
   */
  private emitSelectedIterationIds() {
    this.getHistoryGeometries.emit(
      this.selectedIterations.map(iteration => iteration.iteration_id)
    );
  }

  /**
   * 
   */
  private updateRouteChildrenTableRows() {

    const rows = [];
    console.log('update', this.selectedIterations);

    for (let iteration of this.selectedIterations) {

      for (let segmentId of iteration.segment_ids) {
        rows.push({ iteration_id: iteration.iteration_id, segment_id: segmentId });
      }
    }

    this.routeChildrenTableRows = rows;
  }
}
